import { IDeal } from 'store/deals/types';
import { ISummaryDeal, EForecastEvaluationType, EEvaluationUnit } from 'store/deal-evaluation/types';
import { IFieldOption } from 'store/field-options/types';
import { EDisplay } from 'components/deal-results/product-items';

export enum EDealComparisonAction {
  ADD_DEAL = 'ADD_DEAL',
  ADD_DEALS_FROM_DASHBOARD = 'ADD_DEALS_FROM_DASHBOARD',
  EVALUATE_DEALS = 'EVALUATE_DEALS',
  EVALUATE_DEALS_FAIL = 'EVALUATE_DEALS_FAIL',
  EVALUATE_DEALS_SUCCESS = 'EVALUATE_DEALS_SUCCESS',
  REMOVE_DEAL = 'REMOVE_DEAL',
  REMOVE_ALL_DEALS = 'REMOVE_ALL_DEALS',
  UPDATE_DEAL_ORDER = 'UPDATE_DEAL_ORDER',
  UPDATE_FORECAST_TYPE = 'UPDATE_FORECAST_TYPE',
  UPDATE_SELECTED_DISPLAY = 'UPDATE_SELECTED_DISPLAY',
  SET_COMPARE_DEAL_IDS = 'SET_COMPARE_DEAL_IDS',
}

export interface IDealWithEvaluation {
  deal: IDeal;
  evaluation: ISummaryDeal;
}

export interface IDealWithEvaluation2 {
  deal: IDeal;
  evaluation?: ISummaryDeal;
}

export interface IDealComparisonState {
  compareDealIds: string[];
  error?: Error;
  dealsWithEvaluation: IDealWithEvaluation[];
  forecastType: EForecastEvaluationType;
  selectedDisplay: EDisplay;
}

export interface IDealComparisonProps {
  availableDeals: IDeal[];
  dealsWithEvaluation: IDealWithEvaluation[];
  selectedForecastType: EForecastEvaluationType;
  selectedUnitType: EEvaluationUnit;
  loading: boolean;
  availableProducts?: IFieldOption[];
  compareDealIds: string[];
}
